import Vue from 'vue';
import VueSimpleAlert from "vue-simple-alert";
import App from './App.vue';
import VueCookies from 'vue-cookies'
import Vuelidate from 'vuelidate'
import VueLoading from 'vue-loading-overlay'
import VueAxios from "vue-axios";
import axios from 'axios';
import NavigationPlugin from './plugins/navigation';
import Effects from "@/plugins/effects";
import {BootstrapVue, BootstrapVueIcons, IconsPlugin} from "bootstrap-vue";
import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faAddressBook,
    faArrowLeft,
    faArrowLeftLong,
    faArrowRightLong,
    faBan,
    faBars,
    faBurger,
    faCalendarDays,
    faCartPlus,
    faCartShopping,
    faCashRegister,
    faCheckCircle,
    faChevronLeft,
    faChevronRight,
    faChevronDown,
    faChevronUp,
    faChevronCircleLeft,
    faChevronCircleRight,
    faCircleArrowLeft,
    faInfo,
    faCircleInfo,
    faCircleLeft,
    faCircleMinus,
    faCirclePlus,
    faClock,
    faClockRotateLeft,
    faCoins,
    faCreditCard,
    faEnvelope,
    faExclamationTriangle,
    faEye,
    faEyeSlash,
    faFloppyDisk,
    faHandDots,
    faHome,
    faKey,
    faLock,
    faPencil,
    faPlus,
    faMinus,
    faPowerOff,
    faQrcode,
    faReceipt,
    faRectangleList,
    faSearch,
    faShop,
    faShopSlash,
    faTicket,
    faTimes,
    faTimesCircle,
    faTrashCan,
    faUser,
    faUserGraduate,
    faUtensils,
    faDownload,
    faMoneyBill,
    faExclamationCircle,
    faGift,
    faComment,
    faBarcode,
    faCommentMedical,
    faStar
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {AlertMixin} from "@/components/mixins/alertMixin";
import {loadCss} from "@/utils/loadCss";
import i18n from "@/i18n";
import router from "@/router/index.js";
import {
    faFacebookF,
    faInstagram,
    faTwitter,
    faWindows,
    faMicrosoft,
    faLinkedinIn,
    faYoutube,
    faTiktok,
    faPinterest
} from "@fortawesome/free-brands-svg-icons";
import pinia from "@/stores";
import {install} from '@/services/sw/registrar.ts';
import ConfigPlugin from '@/plugins/config';

install();

Vue.use(VueAxios, axios);
Vue.use(VueSimpleAlert);
Vue.use(VueCookies);
Vue.use(Vuelidate);
Vue.use(VueLoading);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(IconsPlugin);
Vue.use(NavigationPlugin);
Vue.use(Effects);
Vue.use(ConfigPlugin);

const vueApp = new Vue({
    render: h => h(App),
    i18n,
    router,
    pinia,
});

Vue.mixin(AlertMixin);

Vue.config.productionTip = false

// Load custom theme and fonts CSS before mounting the app
Promise.all([
  loadCss(process.env.BASE_URL + 'settings/resources/theme/custom.css'),
  loadCss(process.env.BASE_URL + 'settings/resources/theme/fonts/fonts.css')
])
  .then(() => {
    console.log('Custom theme and fonts CSS loaded successfully');
    vueApp.$mount('#app');
  })
  .catch((error) => {
    console.error('Failed to load custom theme or fonts CSS:', error);
    // Fallback: mount app anyway
    vueApp.$mount('#app');
  });

Vue.component('font-awesome-icon', FontAwesomeIcon)
library.add(
    faAddressBook,
    faArrowLeft,
    faArrowLeftLong,
    faArrowRightLong,
    faBan,
    faBars,
    faBurger,
    faCalendarDays,
    faCartPlus,
    faCartShopping,
    faCashRegister,
    faCheckCircle,
    faChevronLeft,
    faChevronRight,
    faChevronDown,
    faChevronUp,
    faCircleArrowLeft,
    faChevronCircleLeft,
    faChevronCircleRight,
    faInfo,
    faCircleInfo,
    faCircleLeft,
    faCircleMinus,
    faCirclePlus,
    faClock,
    faClockRotateLeft,
    faCoins,
    faCreditCard,
    faEnvelope,
    faExclamationTriangle,
    faEye,
    faEyeSlash,
    faFacebookF,
    faFloppyDisk,
    faHandDots,
    faHome,
    faInstagram,
    faKey,
    faLock,
    faPencil,
    faPlus,
    faMinus,
    faPowerOff,
    faQrcode,
    faReceipt,
    faRectangleList,
    faSearch,
    faShop,
    faShopSlash,
    faTicket,
    faTimes,
    faTimesCircle,
    faTrashCan,
    faTwitter,
    faUser,
    faUserGraduate,
    faUtensils,
    faDownload,
    faMoneyBill,
    faExclamationCircle,
    faGift,
    faComment,
    faBarcode,
    faWindows,
    faMicrosoft,
    faCommentMedical,
    faLinkedinIn,
    faYoutube,
    faStar,
    faTiktok,
    faPinterest
)

// Global error handler
vueApp.errorHandler = (err, vueInstance, info) => {

  // Handle the error globally
  console.error("Global error:", err);
  console.log("Vue instance:", vueInstance);
  console.log("Error info:", info);

  // UI notification
  this.makeToast('warning', this.$t('notification.genericError'));
};

// eslint-disable-next-line no-unused-vars
Vue.mixin({
    data: function() {
        return {
            globalCartObject: [],
            TableMode : false
        }
    },
    computed: {
        shoppingCart() {
            return this.globalCartObject;
        },
        /** @usage <pre>Vue.component('my-component',{ method:{ labelX(){ return this.$t('xyz'); } } }); </pre>
         * <pre><template>{{ labelX(lang) /* lang makes the component 'reactive' and  *\/ }}</template></pre>
         * */
        lang:function (){
            return this.$i18n.locale;
        },
    },
});
